interface IProps {
  count: number;
  singularPrefix?: string;
  pluralPrefix?: string;
  zeroMessage?: string;
  nounSingular?: string;
  nounPlural?: string;
  suffix?: string;
  singularSuffix?: string;
  pluralSuffix?: string;
}

export const RenderCountMessage = ({
  count,
  singularPrefix,
  pluralPrefix,
  zeroMessage,
  nounSingular = 'oferta',
  nounPlural = 'ofertas',
  suffix = '',
  singularSuffix,
  pluralSuffix,
}: IProps) => {
  if (!count)
    return (
      <p>
        {zeroMessage}
        {suffix}
      </p>
    );
  const noun = count === 1 ? nounSingular : nounPlural;
  const prefix = count === 1 ? singularPrefix : pluralPrefix;
  const dynamicSuffix = count === 1 ? singularSuffix ?? suffix : pluralSuffix ?? suffix;
  return (
    <p>
      {prefix && `${prefix} `}
      <strong>
        {count} {noun}
      </strong>
      {dynamicSuffix}
    </p>
  );
};
